import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BASE_URL, INITIAL_TOKEN } from "../../configs/Config.js";

export const baseApi = createApi({
  reducerPath: "baseApi",
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers) => {
      headers.set("token", INITIAL_TOKEN);
      headers.set("Accept", "application/json");
      return headers;
    },
  }),
  endpoints: (builder) => ({}), 
});


export const { reducer: baseReducer } = baseApi; 
